module.exports = __webpack_public_path__ + "img/AB-01.cedef3fb.png";